"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Panel_style_1 = require("./Panel.style");
const Panel = ({ children, ...props }) => {
    return ((0, jsx_runtime_1.jsx)(Panel_style_1.StyledPanel, { ...props, ref: el => { var _a; return (_a = props.measureRef) === null || _a === void 0 ? void 0 : _a.call(props, el); }, children: children }));
};
exports.default = Panel;
